import { useForwardingBatchProvider } from '../../Providers/ForwardingBatchProvider';
import { RenderBatchSectionType } from '../../Types/ForwardingBatchTypes';
import { BatchDocumentsEntries } from './BatchDocumentEntries';

function BatchDocumentsComplete(props: RenderBatchSectionType) {
	const { currentBatchData } = useForwardingBatchProvider();

	if (currentBatchData?.shippingDocuments.length === 0) return null;

	return (
		<div>
			<h5 className='mb-xs'>{props.section.name}</h5>

			<BatchDocumentsEntries {...props} removeDocumentCallback={() => null} />
		</div>
	);
}

export { BatchDocumentsComplete };
